import { CSSProperties, FC, useEffect, useRef } from 'react';
import Lottie from 'lottie-react';

import animationData from '@atom/components/common/svgIcons/aiChatbotAnimatedButton.json';
import { IconButton } from '@atom/mui';

export type ChatIconProps = {
  animated?: boolean;
};

const styles: Record<string, CSSProperties> = {
  icon: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '100%',
    padding: 0,
    height: '2rem',
    width: '2rem',
  },
};

const ChatIcon: FC<ChatIconProps> = ({ animated }) => {
  const lottieRef = useRef(null);

  useEffect(() => {
    if (animated) {
      lottieRef.current.play();
    } else {
      lottieRef.current.goToAndStop(0, true);
    }
  }, [animated]);

  return (
    <IconButton style={styles.icon} disabled>
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop
        autoplay={false}
      />
    </IconButton>
  );
};

export default ChatIcon;
